export default __webpack_public_path__ + "static/media/corporate5.a83d44ae.jpg";